///ts:ref=ArrayUtils
/// <reference path="../utils/ArrayUtils.ts"/> ///ts:ref:generated
///ts:ref=MainLoop
/// <reference path="./MainLoop.ts"/> ///ts:ref:generated
///ts:ref=HTMLUtils
/// <reference path="../utils/HTMLUtils.ts"/> ///ts:ref:generated
namespace PerfMonitor {
	export function init() {
		MainLoop.onEnterFrame.addListener(handler_enterFrame);
		_container = document.createElement('div');
		document.getElementsByTagName('body').item(0).appendChild(_container);
		let style:any = _container.style;
		style['position'] = 'fixed';
		style['font-size'] = '16px';
		style['color'] = '#000000';
		style['background-color'] = 'lightblue';
		style['font-weight'] = 'bold';



		style['-webkit-touch-callout'] = 'none'; /* iOS Safari */
		style['-webkit-user-select: none'] = 'none'; /* Safari */
		style['-khtml-user-select'] = 'none'; /* Konqueror HTML */
		style['-moz-user-select: none'] = 'none'; /* Firefox */
		style['-ms-user-select'] = 'none'; /* Internet Explorer/Edge */
		style['user-select'] = 'none'; /* Non-prefixed version, currently supported by Chrome and Opera */

		HTMLUtils.setTextContent(_container,'FPS');
	}
	var _container:HTMLDivElement;

	var _framesCounter:number = 0;
	const _framesDeltas:Array<number> = new Array<number>();
	const _codeDetails:Array<number> = new Array<number>();
	const measuringCount:number = 180;

	function handler_enterFrame(timeDelta:number):void {
		_framesCounter++;
		
		let fps = 1000 / timeDelta;
		updateCounter(fps);
		let deltas:Array<number> = _framesDeltas;
		deltas.push(timeDelta);
		if (deltas.length > measuringCount) {
			deltas.shift();
		}
	}

	var _introText:string = null;
	var _avgFps:string = '';
	var _lasFpsUpdate:number = 0;
	function updateCounter(fps:number):void {
		let delta = performance.now() - _lasFpsUpdate;
		if (delta >= 500) {
			if (!_introText) {
				let date = new Date(parseInt(BuildProperties.buildDate));;
				_introText = 'Build: ' + date.toLocaleString() + ' FPS: ';
			}
			HTMLUtils.setTextContent(_container, _introText + fps.toFixed(1) + ' AVG: ' + _avgFps);
			_lasFpsUpdate = performance.now();
		}
	}

	export function enterFrameDispatchingTime(timeDelta:number):void {
		_codeDetails.push(timeDelta);
		if (_codeDetails.length > measuringCount) {
			_codeDetails.shift();
		}

		let framesDeltas:Array<number> = _framesDeltas;
		if (_framesCounter >= measuringCount) {
			_avgFps = (1000 / ArrayUtils.avg(framesDeltas)).toFixed(2);
			let minFps = (1000 / ArrayUtils.max(framesDeltas)).toFixed(2);
			let medFps = (1000 / ArrayUtils.percentile(framesDeltas, 0.5)).toFixed(2);

			let avgTime = ArrayUtils.avg(_codeDetails).toFixed(2);
			let maxTime = ArrayUtils.max(_codeDetails).toFixed(2);
			let medTime = ArrayUtils.percentile(_codeDetails, 0.5).toFixed(2);

			PandaConsole.logDebug('AvgFps:', _avgFps, 'MedFps:', medFps, 'MinFps:', minFps, 'AvgCodeMs:', avgTime, 'MaxCodeMs:', maxTime, 'MedCodeMs:', medTime);
			//PandaConsole.logDebug(_codeDetails.map(v=>v.toFixed(2)).join(' '));
			PandaConsole.logDebug(JSON.stringify(PerfUtils.storage));
			_framesCounter = 0;
			PerfUtils.storage = {};
		}
	}
}